import { Offer } from '../../../business/domain/Offer'

export default {
  props: {
    offer: Offer
  },
  methods: {
    selectOffer () {
      this.$emit('select', { ...this.offer })
    }
  }
}
